<template>
  <header>
    <b-navbar toggleable="md" type="dark" class="private">
      <b-navbar-brand id="pdf-logo" to="/home">
        <div class="logo-branding d-flex flex-row">
          <img
              :src="
                '/static/images/unpd/unpd_logo_color_' + lang + '.svg'
              "
              height="105"
              style="margin: -7px -25px 0 0"
          />
          <img
            class="mx-auto d-block"
            :src="'./static/images/GES_Logo.svg'"
            height="90"
          />
        </div>
      </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse" />
      <b-collapse id="nav_collapse" is-nav>
        <b-navbar-nav class="ml-auto title">
          <h1 @click="showLabels">
            <span>{{title}}</span>
          </h1>
        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" style="margin-right: 10px;">
<!--          <template-dashboard-selector v-if="isIndicaUser || isPNUDADMIN"></template-dashboard-selector>-->
          <template-company-selector v-if="areSelectorsAvailable"/>
          <template-snapshot-selector v-if="areSelectorsAvailable"/>
          <template-language-selector />
          <b-nav-item-dropdown right no-caret>
            <!-- Using button-content slot -->
            <template slot="button-content">
              <div :title="$t('headerMenu_user_caption')">
                <icon class="icon-svg" name="user" scale="1.5" />
                <i style="position: absolute; padding-top: 1px; color: #6F3996" class="bi bi-caret-down-fill"></i>
              </div>
            </template>
            <b-dropdown-item @click="logout">
              {{ $t("headerMenu_logout_caption") }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
  </header>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Header",
  data: function () {
    return {
      labelCounter: 5,
      pageTitle: "",
    };
  },
  watch: {
    $route(to) {
      this.pageTitle = to.meta.label;
      if(this.pageTitle === "sideMenu_home_caption")
        this.pageTitle = ""
    },
  },
  computed: {
    areSelectorsAvailable(){
      return (this.getUserAccount.numberOfCompanies || this.getUserAccount.numberOfEvaluationsEvaluator) && !this.$route.meta.hideBusinessSelectorAndTitle;
    },
    title() {
      var temp = this.$t(this.pageTitle);
      var includeYear = false;

      if(!this.$route.meta.hideBusinessSelectorAndTitle) {
        if(temp) {
          temp = temp + " - ";
        }
        includeYear = true
        temp = temp + (this.business.selfAssessment_general_business_companyName ?? '')
      }
      if(['EvaluateEvaluation', 'EvaluateOrganization'].includes(this.$route.name) && this.getSelectedEvaluation && this.getSelectedEvaluation.evaluation_administrator_evaluations_selectTag){
        if(temp != "")
          temp = temp + " - "
        includeYear = true
        temp = temp + this.getSelectedEvaluation.evaluation_administrator_evaluations_selectTag.name
      }
      if(['EvaluateEvaluation', 'EvaluateOrganization'].includes(this.$route.name) && this.getSelectedEvaluation && !this.getSelectedEvaluation.evaluation_administrator_evaluations_selectTag && this.getSelectedEvaluation.business){
        if(temp != "")
          temp = temp + " - "
        includeYear = true
        temp = temp + this.getSelectedEvaluation.business.selfAssessment_general_business_companyName
      }
      if(this.currentSnapshot && includeYear && this.currentSnapshot.date)
          temp = temp + " - " + this.currentSnapshot.date.slice(0, 4)
      return temp;
    },
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters({
      business: "getBusiness",
      getSelectedEvaluation: 'getSelectedEvaluation',
      currentSnapshot: 'getCurrentSnapshot',
      getUserAccount: "getUserAccount",
      isPNUDADMIN:  "isPNUDADMIN",
      isIndicaUser:  "isIndicaUser"
    }),
  },
  mounted(){
    this.pageTitle = this.$route.meta.label;
      if(this.pageTitle === "sideMenu_home_caption")
        this.pageTitle = ""
  },
  methods: {
    logout: async function () {
      await this.$router.push("/logout");
    },
    showLabels: function () {
      this.labelCounter--;
      console.log(
        `Click the logo ${this.labelCounter} times more to see the labels`
      );
      if (this.labelCounter === 0) {
        console.log(
          "To see the translations again, You just need to change the language in the language selector"
        );
        this.labelCounter = 5;
        this.$store.commit("SET_LABEL_LANG");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* components/template/_template-header.vue */
@import "../../assets/css/variables.scss";
header {
  border-bottom: 1.2px solid $primary-color;
  .logo-branding{
    margin: -5px 40px -10px -15px;
  }
  .icon-svg{
    fill: $primary-color;
    padding-top: 3px;
  }
  .navbar {
    font-family: $font-subtitle-light;
    color: #ffffff;
    background-color: $header-accent;
    text-transform: uppercase;
    .nav-link {
      color: #ffffff !important;
    }
    .navbar-brand {
      padding: 0;
    }
    .nav-link {
      color: rgba(255, 255, 255, 1) !important;
    }
  }
  h1{
    max-width: 100%;
  }
  h4 {
    text-align: center;
  }
}
@media (max-width: 768px) {
  header {
    .title {
      display: none;
    }
  }
}
@media (max-width: 425px) {
  header {
    .navbar {
      text-align: center;
      .navbar-brand {
        img {
          height: 40px;
        }
      }
    }
  }
};
</style>
